const SIGNED_DECIMAL = /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/;

function trimDecimalParts(whole: string, fraction: string) {
  const normalizedWhole = whole.replace(/^0+(?=\d)/, "") || "0";
  const normalizedFraction = fraction.replace(/0+$/, "");
  return normalizedFraction ? `${normalizedWhole}.${normalizedFraction}` : normalizedWhole;
}

function shiftUnsigned(value: string, places: number) {
  const [whole, fraction = ""] = value.split(".");
  const digits = `${whole}${fraction}`;
  const point = whole.length + places;
  if (point <= 0) return trimDecimalParts("0", `${"0".repeat(-point)}${digits}`);
  if (point >= digits.length) {
    return trimDecimalParts(`${digits}${"0".repeat(point - digits.length)}`, "");
  }
  return trimDecimalParts(digits.slice(0, point), digits.slice(point));
}

function shiftSigned(value: string, places: number) {
  if (!SIGNED_DECIMAL.test(value)) return value;
  const negative = value.startsWith("-");
  const shifted = shiftUnsigned(negative ? value.slice(1) : value, places);
  return negative && shifted !== "0" ? `-${shifted}` : shifted;
}

/** Convert canonical ratio storage (0.45) to customer percentage points (45). */
export function canonicalRatioToPercent(value: string) {
  return value ? shiftSigned(value, 2) : "";
}

/** Convert customer percentage points (45) to canonical ratio storage (0.45). */
export function percentToCanonicalRatio(value: string) {
  const normalized = value.trim();
  return normalized ? shiftSigned(normalized, -2) : "";
}
